import { render, staticRenderFns } from "./ViewFile.vue?vue&type=template&id=51bc31ad&scoped=true"
import script from "./ViewFile.vue?vue&type=script&lang=js"
export * from "./ViewFile.vue?vue&type=script&lang=js"
import style0 from "./ViewFile.vue?vue&type=style&index=0&id=51bc31ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bc31ad",
  null
  
)

export default component.exports